export default {
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    stateItems: [
      { id: "", title: "Keine Angabe" },
      { id: "open", title: "Geöffnet" },
      { id: "closed", title: "Geschlossen" },
      { id: "highWorkload", title: "Aktuell hohe Auslastung" },
      { id: "capacityExhausted", title: "Belegt/Kapazität erschöpft" },
      { id: "openingHours", title: "Gemäß Öffnungszeiten" }
    ],
    paymentMethods: [
      { value: "cash", text: "Münzen" },
      { value: "debitCard", text: "EC-Karte" },
      { value: "creditCard", text: "Kredit-Karte" },
      { value: "mobilePayment", text: "per Handy" },
      { value: "onlineReservation", text: "Online Reservierung" }
    ],
    withWithoutParkingFeeItems: [
      { value: "", text: "Keine Angabe" },
      { value: "withFee", text: "Kostenpflichtig" },
      { value: "withoutFee", text: "Kostenlos" }
    ]
  }),
  inject: ["sharedState"],
  mounted() {
    this.sharedState.stateItems = this.stateItems;
  }
};
